export const SEARCH_DEVICES = "SEARCH_DEVICES";
export const GET_DEVICE_BYID = "GET_DEVICE_BYID";
export const REGISTER_DEVICE = "REGISTER_DEVICE";
export const UPDATE_DEVICE = "UPDATE_DEVICE";
export const DELETE_DEVICE = "DELETE_DEVICE";
